const doc = [({"ja":({"adminConstantHotelStayType":({"stay":"宿泊のみ", "oneDayTrip":"日帰りのみ", "allTypes":"宿泊と日帰り"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;